export default __webpack_public_path__ + "static/media/home-digital-agency-img-08.a4cd57c6.jpg";